import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { globalRoutes } from "./globalRoutes";
import { Box } from "@mui/material";
import { BUYMATERIAL } from "./constURL";

const Index = (props) => {
  const location = useLocation()
  const routeComponents = globalRoutes.map((item, key) => {
    const RouteElement = item.element;
    const RouteWrapper = item.routeType;

    // Check if it's a route with children (nested routes)
    return (
      <Route path={item.path} key={key} element={
        RouteWrapper ? (
          <RouteWrapper>
            <RouteElement {...props} />
          </RouteWrapper>
        ) : (
          <RouteElement {...props} />
        )
      }>
        {/* Handling child routes */}
        {item.children && item.children.map((child, childKey) => (
          < Route
            key={childKey}
            path={child.path}
            element={< child.element {...props} />}
          />
        ))}
      </Route>
    );
  });

  return (
    <Box sx={{ minHeight: { xs: 'calc(100vh - 355px)', md: 'calc(100vh - 282px)' }, width: "100%", display: location.pathname == BUYMATERIAL ? "block" : "flex", justifyContent: "center" }}>
      <Routes>{routeComponents}</Routes>
    </Box>
  );
};

export default Index;
